'use client';
import { fireAndForget } from '@sandstone/shared-utils';
import { useState, useEffect, useCallback } from 'react';
export function usePostHogEvents(maxEvents = 50) {
    const [events, setEvents] = useState([]);
    const [isCapturing, setIsCapturing] = useState(true);
    useEffect(() => {
        if (!isCapturing)
            return;
        let disposed = false;
        let unsubscribe;
        fireAndForget(async () => {
            const { subscribeAnalyticsEvents } = await import('@sandstone/analytics/client');
            if (disposed)
                return;
            unsubscribe = subscribeAnalyticsEvents(event => {
                setEvents(prev => [
                    ...prev.slice(-(maxEvents - 1)),
                    {
                        id: crypto.randomUUID(),
                        timestamp: new Date(),
                        eventName: event.event,
                        properties: event.properties || {},
                    },
                ]);
            });
        });
        return () => {
            disposed = true;
            unsubscribe?.();
        };
    }, [isCapturing, maxEvents]);
    const clearEvents = useCallback(() => {
        setEvents([]);
    }, []);
    const toggleCapturing = useCallback(() => {
        setIsCapturing(prev => !prev);
    }, []);
    return { events, isCapturing, toggleCapturing, clearEvents };
}
